<template>
    <div class="choose-gift">
        <div class="block md:hidden">
            <gift-type-boxes
                @select-subscription="selectSubscription"
                @select-one-box="selectOneBox"/>
        </div>

        <div class="background divider--container py-2 hidden md:block">
            <gift-type-boxes
                @select-subscription="selectSubscription"
                @select-one-box="selectOneBox"/>
        </div>
    </div>
</template>

<script>
import GiftTypeBoxes from '@/components/partials/account/gifting/GiftTypeBoxes';
import { SECTION_CHOOSE_A_GIFT, GIFT_TYPE_ONE_OFF, GIFT_TYPE_SUBSCRIPTION, PRODUCT_TYPE_MULTI, PRODUCT_TYPE_SINGLE } from '@/constants/Gifting';
import { CSPageEvents } from '@/helpers/GAHelpers';

export default {
    name: 'ChooseGiftType',
    components: {
        GiftTypeBoxes,
    },
    computed: {
        primaryProductsInGiftingEnable() {
            return this.$store.getters['account/getPrimaryProductInGiftingEnabled'];
        },
    },
    methods: {
        selectOneBox() {
            CSPageEvents('giftOneOff', {
                productType: 'gift',
                productName: 'oneOff',
                productCategory: 'oneOffGift',
                frequency: 'once',
            });
            this.$store.commit('gifting/resetState');
            setTimeout(() => {
                this.$store.dispatch('gifting/fetchPrices');
                this.$store.commit('gifting/setDeliveryType', GIFT_TYPE_ONE_OFF);
                this.$store.commit('gifting/setSectionComplete', SECTION_CHOOSE_A_GIFT);
                if (this.primaryProductsInGiftingEnable) this.$router.push({ name: 'account.gifting.choose-your-box-type' });
                else this.$router.push({ name: 'account.gifting.delivery-address' });
            }, 1);
        },
        selectSubscription() {
            CSPageEvents('giftOneOff', {
                productType: 'gift',
                productCategory: 'subscriptionGift',
            });
            this.$store.commit('gifting/resetState');
            setTimeout(() => {
                this.$store.dispatch('gifting/fetchPrices');
                this.$store.commit('gifting/setDeliveryType', GIFT_TYPE_SUBSCRIPTION);
                this.$store.commit('gifting/setSectionComplete', SECTION_CHOOSE_A_GIFT);
                this.$store.commit('gifting/setSelectedBoxName', PRODUCT_TYPE_MULTI);
                this.$router.push({ name: 'account.gifting.number-of-deliveries' });
            }, 1);
        },
    },
    mounted() {
        this.$store.dispatch('gifting/fetchPrices');
    },
};
</script>

<style lang="scss" scoped>
.choose-gift {
    margin-top: -26px;
}
</style>
